import {
  buildDateCreatedWhere,
  type TransferOrderListFilters,
} from '../transfer-order-list-filters/index.js';
import type { GetTransferOrderMetricsQueryVariables } from '../transfer-order-list-operations.js';

export function buildTransferOrderMetricsVariables({
  filters,
  search,
}: {
  filters: TransferOrderListFilters;
  search: string;
}): GetTransferOrderMetricsQueryVariables {
  const dateCreated = buildDateCreatedWhere(filters.dateCreated);
  return {
    brandId: filters.brandId || undefined,
    warehouseId: filters.warehouseId || undefined,
    search: search || undefined,
    where: dateCreated ? { dateCreated } : undefined,
  };
}
